<template>
  <div class="modal-block fade" role="dialog">
    <div class="modal-dialog message-modal" role="document">
      <div class="modal-content" v-if="c_arguments">        
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
        <h2>ATENCIÓN</h2>   
        <div class="modal-content-block" >
          <!-- ALL SECTIONS -->
          
          <!-- Faltante de puntos -->         
          <template v-if="c_arguments.idMsg == 1"><h6>{{ c_arguments.balanceNameAlt }} INSUFICIENTES. DISPONES DE <strong>{{ c_arguments.memberPoints.toLocaleString('es-AR') }} {{ c_arguments.balanceNameAlt }}</strong>. NECESITAS <strong>{{ c_arguments.requiredPoints.toLocaleString('es-AR') }} {{ c_arguments.balanceNameAlt }}</strong> ADICIONALES.</h6></template>

          <!-- SECTION TICKETS -->
          <!-- <template v-if="c_arguments.idMsg == 1001"><h6>LA SELECCIÓN SUPERA LA CANTIDAD DE ENTRADAS INDICADAS.</h6><p>Agregue entradas en el indicador de arriba. Gracias.</p></template> -->
          <!-- <template v-if="c_arguments.idMsg == 1002"><h6>LA SELECCIÓN SUPERA LA CANTIDAD DE ENTRADAS INDICADAS. EL MÁXIMO ES DE <strong>{{ c_arguments.ticketsQtyOperation }}</strong> ENTRADAS POR OPERACIÓN.</h6></template>
          <template v-if="c_arguments.idMsg == 1003"><h6>EL MÁXIMO DE ENTRADAS <strong>{{ c_arguments.title }}</strong> DISPONIBLES ES <strong>{{ c_arguments.ticketsMaxQty }}</strong>.</h6><p>Puede seleccionar otro tipo de entrada. Gracias.</p></template> -->
          <!-- <template v-if="c_arguments.idMsg == 1004"><h6>SE SELECCIONARON <strong>{{ c_arguments.ticketsQtySelected }}</strong> DE LAS <strong>{{ c_arguments.ticketsQtyOperation }}</strong> ENTRADAS QUE SE INDICARON ARRIBA.</h6><p>Si ninguna promoción o descuento se ajusta a su situación, seleccione una entrada a <strong>precio regular</strong>.</p><p>De lo contrario, elimine una entrada del indicador de arriba. Gracias.</p></template> -->
          <!-- <template v-if="c_arguments.idMsg == 1005"><h6>NO SE SELECCIONARON ENTRADAS.</h6><p>Seleccione al menos una entrada. Gracias.</p></template>
          <template v-if="c_arguments.idMsg == 1006"><h6>LA ENTRADA SELECCIONADA NO ES COMBINABLE CON <strong>{{ c_arguments.strTitle }}</strong>.</h6></template> -->
          <!--1007 Mensaje validacion voucher -->
          <!-- <template v-if="c_arguments.idMsg == 1007"><h6>DEBE INGRESAR UN CÓDIGO.</h6></template>
          <template v-if="c_arguments.idMsg == 1008"><h6>LA ENTRADA SELECCIONADA NO ES COMBINABLE CON <strong>{{ m_get_title_ticket_only_buy_or_only_book(true) }}</strong>.</h6></template>
          <template v-if="c_arguments.idMsg == 1009"><h6>LA ENTRADA SELECCIONADA NO ES COMBINABLE CON <strong>{{ m_get_title_ticket_only_buy_or_only_book(false) }}</strong>.</h6></template> -->
                  
          <!-- SECTION SEATS -->
          <!-- Seleccion incorrecta de butacas -->
          <!-- <template v-if="c_arguments.idMsg == 2000"><h6>NO PUEDE SELECCIONAR BUTACAS Y DEJAR UN ASIENTO VACÍO EN MEDIO DE LAS MISMAS.</h6></template>
          <template v-if="c_arguments.idMsg == 2001"><h6>SE SELECCIONARON <strong>{{ c_arguments.seatsSelected }}</strong> DE LAS <strong>{{ c_arguments.seatsQty }}</strong> BUTACAS.</h6></template> -->
                   
          <!-- SECTION CANDY -->
          <template v-if="c_arguments.idMsg == 3000"><h6>EL MÁXIMO ES DE <strong>{{ c_arguments.candysQtyOperation }}</strong> PRODUCTOS POR OPERACIÓN.</h6></template>
          <template v-if="c_arguments.idMsg == 3001"><h6>EL MÁXIMO DE PRODUCTOS <strong>{{ c_arguments.strTitle }}</strong> DISPONIBLES ES <strong>{{ c_arguments.candysMaxQty }}</strong>.</h6><p>Puede seleccionar otro producto. Gracias.</p></template>
          <template v-if="c_arguments.idMsg == 3003"><h6>EL PRODUCTO SELECCIONADO NO ES COMBINABLE CON <strong>{{ c_arguments.strTitle }}</strong>.</h6></template>
          <template v-if="c_arguments.idMsg == 3007"><h6>DEBE INGRESAR UN CÓDIGO.</h6></template>
          <!-- <template v-if="c_arguments.idMsg == 3002"><h6>EL PRODUCTO SELECCIONADO NO ES COMBINABLE CON <strong>{{ m_get_title_candy_only_buy() }}</strong>.</h6></template> -->
        </div>
        <button class="info-btn yellow">ACEPTAR</button>     
      </div>
    </div>	
  </div>
</template>
<script>
require("./../assets/jquery.bpopup.min.js");

export default {
  name: "popupalert",
  data: function() {
    return {
      d_arguments: null,
      bPopup: null
    };
  },
  computed: {
    c_arguments: {
      get() {
        return this.d_arguments;
      },
      set(a) {
        this.d_arguments = a;
      }
    }
  },
  updated() {
    if (this.bPopup) {
      this.bPopup.children(".message-modal").css('margin', '');
      this.bPopup.children(".message-modal").children(".modal-content").css('height', '');

      var windowWidth = $(window).outerWidth();
      var windowHeight = $(window).outerHeight();
      var popupWidth = this.bPopup.width();
      var popupHeight = this.bPopup.height();

      var leftPosition = (windowWidth - popupWidth) / 2;
      var topPosition = (windowHeight - popupHeight) / 2;

      if(windowWidth <= popupWidth) {
        leftPosition = 0;
      }

      if(windowHeight <= popupHeight) {
        this.bPopup.children(".message-modal").css('margin', '10px 0px');
        this.bPopup.children(".message-modal").children(".modal-content").css('height', 'calc(100vh - 20px)');
        this.bPopup.css('z-index', '99999');
        topPosition = 0;
      }

      $(this.$el).css({
        'left': leftPosition + 'px',
        'top': topPosition + 'px'
      });
    }
  },
  methods: {
    //Seteo el object con los atributos a mostrar dependiendo del msj.
    m_open: function(args) {
      this.d_arguments = args;

      var self = this;

      this.bPopup = $(this.$el).bPopup({
        follow: [false, false],
        positionStyle: "fixed",
        position: ['auto', 'auto'],
        closeClass: "close,.message-modal .modal-content .info-btn.yellow",
        onOpen: function() {
          $('body').css('overflow', 'hidden');
        },
        onClose: function() {
          // Restablecer el estilo overflow del body cuando se cierra el popin
          $('body').css('overflow', 'initial');
          $(this.$el).remove();
        }
      });

      // Reposicionar el popup cuando se cambie la orientación del dispositivo
      window.addEventListener('resize', function() {
        self.bPopup.children(".message-modal").css('margin', '');
        self.bPopup.children(".message-modal").children(".modal-content").css('height', '');
        
        var windowWidth = $(window).outerWidth();
        var windowHeight = $(window).outerHeight();
        var popupWidth = self.bPopup.width();
        var popupHeight = self.bPopup.height() + 30;

        if(windowWidth <= 479) {
          popupHeight = popupHeight - 60;
        }

        var leftPosition = (windowWidth - popupWidth) / 2;
        var topPosition = (windowHeight - popupHeight) / 2;

        if(windowWidth <= popupWidth) {
          leftPosition = 0;
        }

        if(windowHeight <= popupHeight) {
          self.bPopup.children(".message-modal").css('margin', '10px 0px');
          self.bPopup.children(".message-modal").children(".modal-content").css('height', 'calc(100vh - 20px)');
          self.bPopup.css('z-index', '99999');
          topPosition = 0;
        }

        $(self.$el).css({
          'left': leftPosition + 'px',
          'top': topPosition + 'px'
        });
      });
    },
    m_get_title_candy_only_buy: function(){
      var result = this.$root.m_first_candy_only_buy();
      result == "" && (result = "UNA DE LAS ENTRADAS SELECCIONADAS")
      return result;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PopupAlert.vue